import { useEffect, useRef } from 'react'
import { useDispatch } from 'react-redux'
import { useLocation, useNavigationType } from 'react-router-dom'

import { locationChange } from '@disco/state-management/actions/RouterActions'
import { abandonSearch } from '@disco/state-management/actions/SearchActions'
import type { RouterLocation } from '@disco/state-management/reducers/router'

import { isExplorerLayoutPath } from 'utils/routing'

export const useRouterSync = () => {
  const location = useLocation()
  const navigationType = useNavigationType()
  const dispatch = useDispatch()
  const previousPathname = useRef<string | null>(null)

  useEffect(() => {
    const routerLocation: RouterLocation = {
      pathname: location.pathname,
      search: location.search,
      hash: location.hash,
      state: location.state,
      key: location.key,
    }

    dispatch(locationChange(routerLocation, navigationType) as any)

    const cameFrom = previousPathname.current
    previousPathname.current = location.pathname

    // A running search would otherwise reload pane 0 and navigate back to the
    // results when it lands, dragging the user off the page they opened. Only
    // leaving the explorer counts: landing on it is what a search itself does
    // when started from another page.
    if (
      cameFrom !== null &&
      cameFrom !== location.pathname &&
      !isExplorerLayoutPath(location.pathname)
    ) {
      dispatch(abandonSearch() as any)
    }
  }, [location, navigationType, dispatch])
}
